@if({
    keyboardIsOpen: keyboardIsOpen$ | async,
    isShowSearch: isShowSearch$ | async
}; as data){
    @if(!isMobilePortrait()){<!--    !MOBILE POTRAIT - DESKTOP,TABLET,MOBILE LANDSCAPE VIEWS -->
        @if(!data.isShowSearch?.isSearch) {
            <div [ngClass]="{'tw-contents': !data.isShowSearch?.isSearch}">
                <div class="tw-h-full tw-flex tw-flex-col" [ngClass]="newUi() ? 'tw-gap-4' : 'tw-gap-2'">
                    @switch (categoryView()) {
                        @case ('tab') {
                            @if (newUi()) {
                                <app-category-tab-v2
                                    class="tw-block tw-shrink-0"
                                    [categoriesSet]="visibleCategories"
                                    [itemsFavorite]="!!itemsFavorite.length"
                                    (categorySelected)="selectCategory($event)"
                                    [initCategorySelected]="selectedCategory"
                                    (goToSection)="goToSection($event)"
                                    [fontNameSize]="categoryFontNameSize()"
                                />
                            } @else {
                                <app-category-tab
                                    [categoriesSet]="visibleCategories"
                                    [itemsFavorite]="!!itemsFavorite.length"
                                    (categorySelected)="selectCategory($event)"
                                    [initCategorySelected]="selectedCategory"
                                    (goToSection)="goToSection($event)"
                                    [fontNameSize]="categoryFontNameSize()"
                                />
                            }
                        }
                        @case ('grid') {
                            @if (newUi()) {
                                <app-category-grid-v2
                                    class="tw-block tw-shrink-0"
                                    [categoriesSet]="visibleCategories"
                                    [itemsFavorite]="!!itemsFavorite.length"
                                    [maxRows]="categoryMaxRows"
                                    (categorySelected)="selectCategory($event)"
                                    [initCategorySelected]="selectedCategory"
                                    (goToSection)="goToSection($event)"
                                    [fontNameSize]="categoryFontNameSize()"
                                />
                            } @else {
                                <div class="tw-overflow-x-hidden" [style.height]="categoryBarHeight.height">
                                    <app-category-grid
                                        class="tw-h-full tw-overflow-y-auto"
                                        [categoriesSet]="visibleCategories"
                                        [itemsFavorite]="!!itemsFavorite.length"
                                        [gridCols]="categoryGridColumns !== -1 ? categoryGridColumns : (bigTablet ? 6 : 4)"
                                        (categorySelected)="selectCategory($event)"
                                        [initCategorySelected]="selectedCategory"
                                        (goToSection)="goToSection($event)"
                                        [fontNameSize]="categoryFontNameSize()"
                                    />
                                </div>
                            }
                        }
                    }
                @if(hasVisibleItems()) {
                    <div class="tw-overflow-auto" [ngClass]="newUi() ? 'tw-min-h-0 tw-flex-1' : ''" [style.height]="newUi() ? null : itemsBarHeight.height">
                        @switch (showcaseMode){
                            @case ('noPhotoGrid'){
                                @if (newUi()) {
                                    <app-showcase-grid-v2
                                        [customClass]="data.keyboardIsOpen?customClassOpenKeyboard:customClassClosedKeyboard"
                                        [itemsSet]="visibleItems" [displayMode]="displayMode" [layout]="'card'" [showThumbnail]="false"
                                        [priceList]="priceList()" [gridCols]="itemGridColumns"
                                        [getStockStatus]="getItemStockStatus" (onItemTap)="addItemToSale($event)"
                                        (onItemPress)="showItem($event)"
                                        [fontNameSize]="fontNameSize()"
                                        [fontPriceSize]="fontPriceSize()"
                                        [showItemIcon]="showItemIcon()"
                                    />
                                } @else {
                                    <app-showcase-grid
                                        [customClass]="data.keyboardIsOpen?customClassOpenKeyboard:customClassClosedKeyboard"
                                        [itemsSet]="visibleItems" [displayMode]="displayMode" [showThumbnail]="false"
                                        [priceList]="priceList()" [gridCols]="itemGridColumns"
                                        [getStockStatus]="getItemStockStatus" (onItemTap)="addItemToSale($event)"
                                        (onItemPress)="showItem($event)"
                                        [fontNameSize]="fontNameSize()"
                                        [fontPriceSize]="fontPriceSize()"
                                        [showItemIcon]="showItemIcon()"
                                    />
                                }
                            }
                            @case ('photoGrid'){
                                @if (newUi()) {
                                    <app-showcase-grid-v2
                                        [customClass]="data.keyboardIsOpen?customClassOpenKeyboard:customClassClosedKeyboard"
                                        [itemsSet]="visibleItems" [displayMode]="displayMode" [layout]="'card'" [showThumbnail]="true"
                                        [priceList]="priceList()" [gridCols]="itemGridColumns"
                                        [getStockStatus]="getItemStockStatus" (onItemTap)="addItemToSale($event)"
                                        (onItemPress)="showItem($event)"
                                        [fontNameSize]="fontNameSize()"
                                        [fontPriceSize]="fontPriceSize()"
                                        [showItemIcon]="showItemIcon()"
                                    />
                                } @else {
                                    <app-showcase-grid
                                        [customClass]="data.keyboardIsOpen?customClassOpenKeyboard:customClassClosedKeyboard"
                                        [itemsSet]="visibleItems" [displayMode]="displayMode" [showThumbnail]="true"
                                        [priceList]="priceList()" [gridCols]="itemGridColumns"
                                        [getStockStatus]="getItemStockStatus" (onItemTap)="addItemToSale($event)"
                                        (onItemPress)="showItem($event)"
                                        [fontNameSize]="fontNameSize()"
                                        [fontPriceSize]="fontPriceSize()"
                                        [showItemIcon]="showItemIcon()"
                                    />
                                }
                            }
                            @case ('tab'){
                                @if (newUi()) {
                                    <app-showcase-grid-v2
                                        [customClass]="data.keyboardIsOpen?customClassOpenKeyboard:customClassClosedKeyboard"
                                        [itemsSet]="visibleItems" [displayMode]="displayMode" [layout]="'tab'" [showThumbnail]="true"
                                        [priceList]="priceList()" [gridCols]="itemGridColumns"
                                        [getStockStatus]="getItemStockStatus" (onItemTap)="addItemToSale($event)"
                                        (onItemPress)="showItem($event)"
                                        [fontNameSize]="fontNameSize()"
                                        [fontPriceSize]="fontPriceSize()"
                                        [showItemIcon]="showItemIcon()"
                                    />
                                } @else {
                                    <app-showcase-grid
                                        [customClass]="data.keyboardIsOpen?customClassOpenKeyboard:customClassClosedKeyboard"
                                        [itemsSet]="visibleItems" [displayMode]="displayMode" [showThumbnail]="true"
                                        [priceList]="priceList()" [gridCols]="itemGridColumns"
                                        [getStockStatus]="getItemStockStatus" (onItemTap)="addItemToSale($event)"
                                        (onItemPress)="showItem($event)"
                                        [fontNameSize]="fontNameSize()"
                                        [fontPriceSize]="fontPriceSize()"
                                        [showItemIcon]="showItemIcon()"
                                    />
                                }
                            }
                            @case ('list'){
                                @if (newUi()) {
                                    <app-showcase-list-v2
                                        class="tw-flex tw-flex-col tw-h-full"
                                        [customClass]="data.keyboardIsOpen?customClassOpenKeyboard:customClassClosedKeyboard"
                                        [itemsSet]="visibleItems"
                                        [priceList]="priceList()" [getStockStatus]="getItemStockStatus"
                                        (onItemTap)="addItemToSale($event)"
                                        (onItemPress)="showItem($event)"
                                        [fontNameSize]="fontNameSize()"
                                        [fontPriceSize]="fontPriceSize()"
                                        [showItemIcon]="showItemIcon()"
                                    />
                                } @else {
                                    <app-showcase-list
                                        class="tw-flex tw-flex-col tw-h-full"
                                        [customClass]="data.keyboardIsOpen?customClassOpenKeyboard:customClassClosedKeyboard"
                                        [itemsSet]="visibleItems"
                                        [priceList]="priceList()" [getStockStatus]="getItemStockStatus"
                                        (onItemTap)="addItemToSale($event)"
                                        (onItemPress)="showItem($event)"
                                        [fontNameSize]="fontNameSize()"
                                        [fontPriceSize]="fontPriceSize()"
                                        [showItemIcon]="showItemIcon()" 
                                    />
                                }
                            }
                            @default {
                                <div>ERRORE DI VISUALIZZAZIONE</div>
                            }
                        }
                    </div>
                } @else {
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-[calc(100%-162px)]">
                        <img style="width:30%" src="assets/images/items/no-items.png" alt=""/>
                        <div>{{ 'CASHREGISTER.SHOWCASE.NO_ITEM_AVAILABLE' | translate }}</div>
                    </div>
                }
                </div>
            </div>
        } @else {
            <div [ngClass]="{'adjust-search': data.isShowSearch?.isSearch}">
                <app-cashregister-search-items-wrapper
                    [searchValue]="data.isShowSearch?.searchValue || ''"
                    [items]="items"
                    [showcaseView]="showcaseView"
                    [visibleCategories]="visibleCategories"
                    [selectedCategory]="selectedCategory"
                    [priceListStr]="priceListStr()"
                    [showUnavailable]="showUnavailable"
                    [countNoStockAsUnavailable]="countNoStockAsUnavailable"
                    [getItemStockStatus]="getItemStockStatus"
                    (showItem)="showItem($event)"
                    (addItemToSale)="addItemToSale($event)"
                    [getItemPriceList]="getItemPriceList"
                    [fontNameSize]="fontNameSize()"
                    [fontPriceSize]="fontPriceSize()"
                    [showItemIcon]="showItemIcon()" 
                />
            </div>
        }
    }
    @else { <!--    MOBILE POTRAIT - MOBILE POTRAIT VIEW    -->
        @if(!data.isShowSearch?.isSearch){
            <div [ngClass]="{'tw-grid tw-h-full tw-gap-1 tw-grid-cols-12 adjust': !data.isShowSearch?.isSearch}">
                @if (newUi()) {
                    <app-category-grid-v2 class="tw-col-span-4 tw-block tw-h-full tw-min-h-0"
                        [categoriesSet]="visibleCategories"
                        [itemsFavorite]="!!itemsFavorite.length"
                        [customClass]="data.keyboardIsOpen?customClassOpenKeyboard:customClassClosedKeyboard"
                        [gridCols]="1" (categorySelected)="selectCategory($event)"
                        (goToSection)="goToSection($event)"
                        [fontNameSize]="categoryFontNameSize()"
                    />
                } @else {
                    <app-category-grid class="tw-col-span-4 tw-h-full tw-overflow-y-auto"
                        [categoriesSet]="visibleCategories"
                        [itemsFavorite]="!!itemsFavorite.length"
                        [customClass]="data.keyboardIsOpen?customClassOpenKeyboard:customClassClosedKeyboard"
                        [gridCols]="1" (categorySelected)="selectCategory($event)"
                        (goToSection)="goToSection($event)"
                        [fontNameSize]="categoryFontNameSize()"
                    />
                }
                <div class="tw-block tw-col-span-8 tw-h-full">
                    @if (newUi()) {
                        <app-showcase-list-v2 class="tw-flex tw-flex-col tw-h-full"
                            [customClass]="data.keyboardIsOpen?customClassOpenKeyboard:customClassClosedKeyboard"
                            [showThumbnail]="false"
                            [showUnavailableStock]="false"
                            [priceWithCurrency]="false"
                            [itemsSet]="visibleItems"
                            [priceList]="priceList()"
                            [getStockStatus]="getItemStockStatus"
                            (onItemTap)="addItemToSale($event)"
                            (onItemPress)="showItem($event)"
                            [fontNameSize]="fontNameSize()"
                            [fontPriceSize]="fontPriceSize()"
                            [showItemIcon]="showItemIcon()"
                        />
                    } @else {
                        <app-showcase-list class="tw-flex tw-flex-col tw-h-full"
                            [customClass]="data.keyboardIsOpen?customClassOpenKeyboard:customClassClosedKeyboard"
                            [showThumbnail]="false"
                            [showUnavailableStock]="false"
                            [truncatePriceWithDots]="false"
                            [priceWithCurrency]="false"
                            [itemsSet]="visibleItems"
                            [priceList]="priceList()"
                            [getStockStatus]="getItemStockStatus"
                            (onItemTap)="addItemToSale($event)"
                            (onItemPress)="showItem($event)"
                            [fontNameSize]="fontNameSize()"
                            [fontPriceSize]="fontPriceSize()"
                            [showItemIcon]="showItemIcon()"
                        />
                    }
                </div>
            </div>
        } @else {
            <div class="tw-block tw-h-full">
                <app-cashregister-search-items-wrapper 
                    [searchValue]="data.isShowSearch?.searchValue || ''" 
                    [items]="items" 
                    [showcaseView]="showcaseView" 
                    [visibleCategories]="visibleCategories" 
                    [selectedCategory]="selectedCategory" 
                    [priceListStr]="priceListStr()" 
                    [showUnavailable]="showUnavailable" 
                    [countNoStockAsUnavailable]="countNoStockAsUnavailable"
                    [getItemStockStatus]="getItemStockStatus" 
                    (showItem)="showItem($event)" 
                    (addItemToSale)="addItemToSale($event)" 
                    [getItemPriceList]="getItemPriceList">
                </app-cashregister-search-items-wrapper>
            </div>
        }
    }
}
